import PageTitle from '../blog/PageTitle';
import SectionContainer from '../blog/SectionContainer';
// import { CommonSEO } from "../blog/SEO";
import formatDate from '../../lib/utils/formatDate';
import ScrollTopAndComment from '../blog/ScrollTopAndComment';

export default function PostLayout({ frontMatter, children }) {
  const { date, title, summary, images } = frontMatter;

  return (
    <SectionContainer>
      {/* <CommonSEO
                title={title}
                description={summary}
                ogImage={images ? images[0] : null}
            /> */}
      <ScrollTopAndComment />
      <article className="prose mx-auto">
        <div>
          <header>
            <div className="pb-4 space-y-1 text-center border-b border-gray-200 dark:border-gray-700">
              {date && (
                <dl>
                  <div>
                    <dt className="sr-only">Published on</dt>
                    <dd className="text-base font-medium leading-6 text-gray-500 dark:text-gray-400">
                      <time dateTime={date}>{formatDate(date)}</time>
                    </dd>
                  </div>
                </dl>
              )}
              <div>
                <PageTitle>{title}</PageTitle>
              </div>
            </div>
          </header>
          <div
            className="pb-8 divide-y divide-gray-200 xl:divide-y-0 dark:divide-gray-700 "
            style={{ gridTemplateRows: 'auto 1fr' }}
          >
            <div className="divide-y divide-gray-200 dark:divide-gray-700 xl:pb-0 xl:col-span-3 xl:row-span-2">
              <div className="pt-10 pb-8 prose dark:prose-dark max-w-none">{children}</div>
            </div>
            <footer />
          </div>
        </div>
      </article>
    </SectionContainer>
  );
}
